import { PropsWithChildren } from 'react'

import { isGemPackProduct, ProductV2 } from '@common'
import cx from 'classnames'

import clashColors from '@/features/storefronts/_storeBase/card/v2/OfferCard/games/clashofclans/colors.module.scss'
import { isScenery, isSkin, isStoreSpecial } from '@/features/storefronts/productFilters'
import { isOffer } from '@/utils/products'

import styles from './ClashOfClansContainer.module.scss'

export type Props = PropsWithChildren<{
  product: ProductV2
  className?: string
  type?: 'plp' | 'pdp' | undefined
}>

const clashAssetColor = (product: ProductV2, type?: 'plp' | 'pdp'): string => {
  const isPass = !!product.contentCounts.SEASON_PASS
  const isSeasonPass = isPass && product.type === 'product'

  if (isStoreSpecial(product) && type !== 'pdp') {
    return 'brown'
  }
  if (product.contents.length === 1) {
    if (isSkin(product)) {
      return 'green'
    }
    if (isScenery(product)) {
      return 'blue'
    }
    if (isGemPackProduct(product)) {
      return 'turquoise'
    }
    if (isSeasonPass) {
      return 'gold'
    }
    if (isPass) {
      return 'yellow'
    }
  }
  if (isOffer(product)) {
    return 'purple'
  }
  return 'yellow'
}

export function ClashOfClansContainer({ children, product, className, type }: Props) {
  if (product.contents.length === 1) {
    return (
      <SingleProductContainer product={product} className={className} type={type}>
        {children}
      </SingleProductContainer>
    )
  }

  return (
    <MultiProductContainer product={product} className={className}>
      {children}
    </MultiProductContainer>
  )
}

function SingleProductContainer({ product, className, children, type }: Props) {
  const colorScheme = clashAssetColor(product, type)

  return (
    <div className={cx(styles.Container, className, styles[product.game], clashColors[colorScheme])}>{children}</div>
  )
}

function MultiProductContainer({ product, className, children }: Props) {
  const colorScheme = clashAssetColor(product)
  return (
    <div
      className={cx(
        styles.Container,
        clashColors[colorScheme],
        styles.MultiProductContainer,
        className,
        styles[product.game],
      )}
    >
      {children}
    </div>
  )
}
